import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const FormRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;

  > div {
    flex: 1;
  }
`;

export const LogsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.neutral.dark};
  }
`;

export const LogsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

// Quantos corpos já passaram da retenção — o expurgo é manual, então o número
// precisa estar visível para o admin saber que há o que limpar.
export const ExpiredInfo = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.dark};
`;

// Envios que falharam e estão na fila de reenvio. Em destaque (não é uma
// informação neutra: alguém não recebeu o e-mail ainda).
export const PendingInfo = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.feedbackState.warning.darked};
`;

// Preview do corpo do e-mail: HTML de terceiros renderizado dentro do painel.
// O iframe com sandbox vazio bloqueia script/form/navegação e isola o CSS.
export const BodyFrame = styled.iframe`
  width: 100%;
  min-height: 60vh;
  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza200};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const BodyEmpty = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.dark};
`;
